import React from 'react';
import { Users, UserCheck, UserX, UserRound } from 'lucide-react';
import { StatCard } from '../../common';
import { formatNumber } from '../../../utils/format';
import { useUserAnalytics } from './userAnalytics.controller';
import { t } from '../../../company/labels';

export default function UserAnalytics({ users }) {
    const analytics = useUserAnalytics(users);

    return (
        <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 mb-4">
            <StatCard
                label="Total Usuarios"
                value={formatNumber(analytics.totalUsers)}
                icon={<Users />}
                tone="violet"
                hint={`${analytics.gerentes} gerentes · ${analytics.asesores} asesores`}
            />
            <StatCard label="Usuarios Activos" value={formatNumber(analytics.activeUsers)} icon={<UserCheck />} tone="success" hint="Con acceso al sistema" />
            <StatCard label="Usuarios Inactivos" value={formatNumber(analytics.inactiveUsers)} icon={<UserX />} tone="danger" hint="Sin acceso al sistema" />
            <StatCard label={t('promotores')} value={formatNumber(analytics.promotores)} icon={<UserRound />} tone="warning" hint="Personal de campo" />
        </div>
    );
}
